<ion-grid class="confirmation-body">
    <ion-row>
      <ion-col size-sm="7" size-md="7" size-lg="6" size-xs="7">
        <div *ngIf="popupName == 'Competency Set'" class="fs-18 font_bold cl-black">Competency Set Status: ({{competencyemployee.length}})</div>
        <div *ngIf="popupName == 'Evaluated by Manager'" class="fs-18 font_bold cl-black">Evaluated by Manager: ({{competencyemployee.length}})</div>
      </ion-col>
      <ion-col size-sm="5" size-md="5" size-lg="6" size-xs="5" class="text-right">
        <div class="center-content justify-content-flex-end">
          <label *ngIf="popupName == 'Competency Set'" class="mr-10">Incomplete</label>
          <label *ngIf="popupName == 'Evaluated by Manager'" class="mr-10">Not Evaluated</label>
          <mat-slide-toggle class="mr-10" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
          <label *ngIf="popupName == 'Competency Set'" class="mr-10">Completed</label>
          <label *ngIf="popupName == 'Evaluated by Manager'" class="mr-10">Evaluated</label>
          <button (click)="exportDashboardListExcel()" class="mr-10 Download fs-16 font_semibold"><img src="././assets/icon/yellowdownload.png"
            class="downIcon">Download</button>
          <div class="close_bg display-center cp" [mat-dialog-close]>
            <img src="././assets/icon/close_icon.png" class="closeHeight">
          </div>
       </div>
      </ion-col>
    </ion-row>
  <div class="table-scroll" *ngIf="popupName == 'Competency Set'">
    <table class="hover mb-15">
      <thead>
        <tr>
          <th class="fs-14 font_bold cl-black">Dept/Function</th>
          <th class="fs-14 font_bold cl-black">{{setupGradeBrand}}</th>
          <th class="fs-14 font_bold cl-black">Competency Name</th>
          <th class="fs-14 font_bold cl-black">Competency Defination</th>
          <th class="fs-14 font_bold cl-black">WT</th>
          <th class="fs-14 font_bold cl-black">Published On</th>
          <th class="fs-14 font_bold cl-black">Created By</th>
          <th class="fs-14 font_bold cl-black">Last Modified By</th>
        </tr>
      </thead>
      <tbody *ngIf="!isToggleOn">
        <ng-container *ngFor="let item of competencyemployee; let empIndex = index">
          <!-- <ng-container *ngFor="let competency of item.competencyMasterlist; let i = index"> -->
            <tr>
              <ng-container>
                <td class="fs-14 font_regular">
                  {{ item.functionName }}
                </td>
                <td class="fs-14 font_regular">
                  {{ item.band }}
                </td>
              </ng-container>
              <td class="fs-14 font_regular"></td>
              <td class="fs-14 font_regular"></td>
              <td class="fs-14 font_regular"></td>
              <td class="fs-14 font_regular"></td>
              <td class="fs-14 font_regular"></td>
              <td class="fs-14 font_regular"></td>
            </tr>
          <!-- </ng-container> -->
          <!-- <tr class="total-row">
            <td colspan="5" class="fs-14 font_bold cl-black text-right"></td>
            <td class="fs-14 font_bold cl-black">
            </td>
            <td colspan="4"></td>
          </tr> -->
        </ng-container>
      </tbody>
      <tbody *ngIf="isToggleOn">
        <ng-container *ngFor="let item of competencyemployee; let empIndex = index">
          <ng-container *ngFor="let competency of item.competencyMasterlist; let i = index">
            <tr>
              <ng-container *ngIf="i === 0">
                <td class="fs-14 font_regular" [attr.rowspan]="item.competencyMasterlist.length">
                  {{ item.functionName }}
                </td>
                <td class="fs-14 font_regular" [attr.rowspan]="item.competencyMasterlist.length">
                  {{ item.band }}
                </td>
              </ng-container>
              <td class="fs-14 font_regular">{{ competency?.competencyName }}</td>
              <td class="fs-14 font_regular">{{ competency?.competencyDefination }}</td>
              <td class="fs-14 font_regular">{{ competency?.weightageNo }}</td>
              <td class="fs-14 font_regular">{{ item.formattedPublishedOn}}</td>
              <td class="fs-14 font_regular">{{ item.createdBy }} | {{ item.formattedCreatedAt }}</td>
              <td class="fs-14 font_regular">{{ item.lastModifiedBy }} | {{ item.formattedLastModifiedOn }}</td>
            </tr>
          </ng-container>
          <tr class="total-row">
            <td colspan="5" class="fs-14 font_bold cl-black text-right"></td>
            <td class="fs-14 font_bold cl-black">Total :<span class="orangecolor">{{getTotalWeight(item)}}</span>
            </td>
            <td colspan="4"></td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div class="table-scroll" *ngIf="popupName == 'Evaluated by Manager'">
    <table class="hover mb-15">
      <thead>
        <tr>
          <th class="fs-14 font_bold cl-black">Employee Name</th>
          <th class="fs-14 font_bold cl-black">Manager name</th>
          <th class="fs-14 font_bold cl-black">Dept/Function</th>
          <th class="fs-14 font_bold cl-black">{{setupGradeBrand}}</th>
          <th class="fs-14 font_bold cl-black">Evaluated date</th>
          <th class="fs-14 font_bold cl-black">Score</th>
          <th class="fs-14 font_bold cl-black">Rating</th>
          <th class="fs-14 font_bold cl-black">Manager Comment</th>
          <th class="fs-14 font_bold cl-black">Employee Comment</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of competencyemployee; let empIndex = index">
            <tr>
              <td class="fs-14 font_regular">{{ item.employeeName }}</td>
              <td class="fs-14 font_regular">{{ item.managerName }}</td>
              <td class="fs-14 font_regular">{{ item.function }}</td>
              <td class="fs-14 font_regular">{{ item.band }}</td>
              <td class="fs-14 font_regular">{{ item.evaluatedDate|date:'dd-MM-yyyy | hh:mm a' }}</td>
              <td class="fs-14 font_regular">{{ item.score }}</td>
              <td class="fs-14 font_regular">{{ item.rating }}</td>
              <td class="fs-14 font_regular">{{ item.managerComment }}</td>
              <td class="fs-14 font_regular">{{ item.employeeComment }}</td>
            </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ion-grid>